import Entity from 'utilities/entity';
import Phase from './phase';

class Activity extends Entity {
  phases() {
    return this.hasMany(Phase);
  }

  // skills() {
  //     return this.hasMany(Skill);
  // }
}

export default new Activity();
